export default class LanguageHandler {
    public static getCurrentLanguage = (): string => {
        const htmlLang: string = document.querySelector('html').getAttribute('lang') || 'de-DE';
        const langParts: string[] = htmlLang.split(/[-_]+/);
        // theoretically, langParts[1] could contain the country code of the current region
        return langParts[0];
    }
}
